import {
  collection,
  collectionGroup,
  getDocs,
  or,
  query,
  where,
} from "firebase/firestore";
import db from "./fireInit";

async function searchObject(
  searchInput,
  boxType,
  onSearched,
  includeCategories,
  payload
) {
  const queries = [
    where("searchArray", "array-contains", searchInput),
    where("keywords", "array-contains", searchInput),
  ];
  if (includeCategories) {
    queries.push(
      where("categories", "array-contains", searchInput.toLowerCase())
    );
  }
  const colRef = collection(db, `boxes/${boxType.names.plural}/collection`);

  const q = query(colRef, or(...queries));

  const docs = [];
  const snapshot = await getDocs(q);
  snapshot.forEach((snap) => {
    docs.push(snap.data());
  });

  onSearched(docs, boxType.names.plural);
}

async function searchAllObjects(searchInput, onSearched, payload) {
  const colGroup = collectionGroup(db, "collection");
  const q = query(
    colGroup,
    or(
      where("searchArray", "array-contains", searchInput.toLowerCase()),
      where("keywords", "array-contains", searchInput.toLowerCase())
    )
  );

  const docs = [];
  const snapshot = await getDocs(q);
  snapshot.forEach((snap) => {
    docs.push(snap.data());
  });

  onSearched(docs, payload);
}

async function queryRelatedTypes(list, onReceived) {
  const colRef = collection(db, "boxTypes");
  const q = query(colRef, where("names.plural", "in", list));
  const qSnap = await getDocs(q);
  const foundDocs = [];
  qSnap.forEach((doc) => {
    foundDocs.push(doc.data());
  });
  onReceived(foundDocs);
}

export { searchObject, searchAllObjects, queryRelatedTypes };
